import type { CSSProperties, ReactNode } from 'react'
import { ActionMenu, type ActionMenuItem } from './ActionMenu'
import type { FloatingMenuPlacement } from './FloatingMenu'

export type DropdownMenuItem = ActionMenuItem

type DropdownMenuProps = {
  trigger: (state: { open: boolean; toggle: () => void; anchorRef: (node: HTMLButtonElement | null) => void }) => ReactNode
  items: DropdownMenuItem[]
  ariaLabel: string
  emptyLabel?: string
  placement?: FloatingMenuPlacement
  matchAnchorWidth?: boolean
  minWidth?: number
  className?: string
  style?: CSSProperties
}

/**
 * Action menu built on FloatingMenu. Use anywhere you need a click-to-open list
 * of actions (not a single-value picker — for that use `<Select>`).
 *
 * @deprecated Use `<ActionMenu>` directly. This wrapper exists for caller
 * compatibility and will be removed in Phase 4.
 */
export const DropdownMenu = ({
  trigger,
  items,
  ariaLabel,
  emptyLabel,
  placement = 'bottom-start',
  matchAnchorWidth = false,
  minWidth,
  className,
  style,
}: DropdownMenuProps) => (
  <ActionMenu
    renderTrigger={trigger}
    items={items}
    ariaLabel={ariaLabel}
    emptyLabel={emptyLabel}
    placement={placement}
    matchAnchorWidth={matchAnchorWidth}
    minWidth={minWidth}
    className={`unifiedDropdownMenu ${className ?? ''}`.trim()}
    style={style}
  />
)
